module.exports = __webpack_public_path__ + "static/media/facility.4481369d.svg";